import styled from 'styled-components';

export const PageContainer = styled.div`
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin: ${(props) => (props.mobileView ? '0 3%;' : '0 15%;')}
  `;

export const OptionContanier = styled.div`
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex-grow: 3;
  width: 60%;
  min-height: 320px;
  padding-top: 10px;
`;

export const GoalcardContainer = styled.div`
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex-grow: 1;
  width: 34%;
  min-height: 250px;
  min-width: 250px;
  padding-top: 10px;
`;

export const ButtonContainer = styled.div`
  display:flex;
  flex-direction: row;
  padding: 25px 30px;
  font-family: 'Avenir Next LT W01 Demi';
  justify-content: ${(props) => (props.mobileView ? 'center;' : 'flex-start;')}
  margin: ${(props) => (props.mobileView ? '' : '0 14%;')}
`;

export const Button = styled.button`
  width: 180px;
  height: 45px;
  line-height: 45px;
  background-color: #F3A802;
  outline: none;
  border: 0;
  border-radius: 5px;
  color: #fff;
  text-transform: uppercase;
  font-size: .9em;
  text-align: center;
  opacity: 1;
  padding: 0 18px;
  box-sizing: border-box;
  cursor: pointer;
  font-family: 'Avenir Next LT W01 Demi';
  ${(props) => (props.disabled
    ? 'background-color: #a3a3a3;'
    : 'background-color: #F3A802;')}
`;
